import React from "react";
import { useKeycloak } from "@react-keycloak/web";

interface OwnProps {
    children: React.ReactNode;
}

export const KeycloakLoggedIn: React.FC<OwnProps> = (props) => {
    const { keycloak } = useKeycloak();
    return (keycloak?.authenticated ? <>{props.children}</> : null);
};

export const KeycloakNotLoggedIn: React.FC<OwnProps> = (props) => {
    const { keycloak } = useKeycloak();
    return (keycloak?.authenticated ? null : <>{props.children}</>);
};
